@if (flags(); as flags) {
  <onyx-flags [flags]="flags"></onyx-flags>
} @else {
  -
}
